import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { Provider as GlobalStateProvider } from 'src/components/base/globalState';
import { RegistrationDataProvider } from 'src/components/base/registrationData';
import { apolloClient } from 'src/lib/apolloClient';

/**
 * Single place to compose all app-wide context providers, so gatsby-browser.js and
 * gatsby-ssr.js can share one `wrapRootElement` implementation instead of duplicating the nesting.
 */
export const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <ApolloProvider client={apolloClient}>
    <GlobalStateProvider>
      <RegistrationDataProvider>{children}</RegistrationDataProvider>
    </GlobalStateProvider>
  </ApolloProvider>
);
